import { NgModule, Injector } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './/app-routing.module';
import { AdminModule } from './/admin/admin.module';
import { LoginModule } from './/login/login.module';
import { AppComponent } from './app.component';
import { ShareModule } from './share.module';
import { setAppInjector } from './authorizePP/app-injector';
import { PublicComponent } from './public/index.component';

@NgModule({
  declarations: [
    //app main
    AppComponent,
    PublicComponent
  ],
  imports: [
    BrowserModule,
    AdminModule,
    LoginModule,
    ShareModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { 
    constructor(injector: Injector) {
      setAppInjector(injector);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts